import { Box, Grid, IconButton, Typography } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext, useEffect } from "react";

import BannerWrapper from "../BannerWrapper";
import { useCountDown } from "../useCountdown";

const EndOfYearSale = () => {
  const { subscription } = useContext(SubscriptionContext);
  const { display, createTimer } = useCountDown();

  useEffect(() => {
    createTimer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return display ? (
    <BannerWrapper>
      <Grid container alignItems={"center"} justifyContent={"center"}>
        <Typography
          sx={{ fontSize: { xs: 10, md: 14, color: "white" } }}
          textAlign="center"
        >
          🔥 End of year sale: Only <strong>{display} Left!</strong> Save{" "}
          {subscription?.bannerPromoCode?.discountPercent}% if you subscribe to{" "}
          <strong>Pro or Virtual Assistant</strong> plans.
        </Typography>

        <IconButton sx={{ fontSize: 14 }}>
          <Box
            component="i"
            className="fa-regular fa-arrow-right"
            sx={{ color: "white" }}
          />
        </IconButton>
      </Grid>
    </BannerWrapper>
  ) : (
    <></>
  );
};

export default EndOfYearSale;
